import { createSelector } from 'reselect';

import getAllDocuments from './getAllDocuments';
import { CylinderType } from 'src/types/transforms';

const getAllCylinderWarps = createSelector([getAllDocuments], (documents) =>
    documents.filter((doc) => doc.cylinder).map((doc) => ({ id: doc.id, ...doc.cylinder }) as CylinderType),
);

export default getAllCylinderWarps;
